/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { isEmpty, uniq } from 'lodash';

import {
  defaultProductAttribute,
} from '../../../../utils/defaultData';

export const useProductAttribute = ({
  attributesOptions,
  categoriesAttributesFetched,
  fetchedAttributeOptions,
  fetchedAttributesOptions,
  categoriesAttributes,
  setProductCategoriesAttributes,
  productCategoriesAttributes,
  navigationItem,
  fetchAttributesOptions,
  filters,
  navigationFetched,
  fetchCategoriesAttributes,
  fetchPhysicalCategoriesByIds,
}) => {
  const getAttributeOptions = (attr) => {
    const attribute = attributesOptions.find(ao => ao.code === attr);
    return attribute ? attribute.options : [];
  };

  const mapAttributesOptions = attributes => attributes.map((a) => {
    if ((a.frontendInputType === 'select'
    || a.frontendInputType === 'dropdown'
    || a.frontendInputType.startsWith('dropdown_')) && isEmpty(a.options)) {
      return {
        ...a,
        options: getAttributeOptions(a.code),
      };
    }
    return a;
  });

  useEffect(() => {
    if (categoriesAttributesFetched) {
      const updatedAttributes = [
        ...categoriesAttributes, defaultProductAttribute,
      ];
      const updatedList = mapAttributesOptions(updatedAttributes);
      setProductCategoriesAttributes(updatedList);
    }
  }, [categoriesAttributesFetched]);

  useEffect(() => {
    if (fetchedAttributeOptions || fetchedAttributesOptions) {
      const hasProductId = productCategoriesAttributes.some(pC => pC.code === 'id');
      const updatedList = mapAttributesOptions([
        ...productCategoriesAttributes, !hasProductId
          ? defaultProductAttribute
          : [],
      ].flat());
      setProductCategoriesAttributes(updatedList);
    }
  }, [
    fetchedAttributeOptions,
    fetchedAttributesOptions,
  ]);

  useEffect(() => {
    if (navigationFetched) {
      const physicalCategories = isEmpty(navigationItem.virtualParams.mappedCategories)
        ? navigationItem.virtualParams.selectedCategories
        : navigationItem.virtualParams.mappedCategories;

      if (
        navigationItem.virtualParams
        && !isEmpty(physicalCategories)
      ) {
        fetchCategoriesAttributes(uniq(physicalCategories));
        fetchPhysicalCategoriesByIds(uniq(physicalCategories));
      }
    }
  }, [navigationFetched]);


  useEffect(() => {
    if (!isEmpty(navigationItem) && !isEmpty(navigationItem.virtualParams.filters)) {
      const { filters: categoryFilters } = navigationItem.virtualParams;
      const fields = categoryFilters.map(f => f.group.map(g => g.field)).flat();
      const aoFields = fields.filter(ao => ao.startsWith('ao_'));

      if (!fetchedAttributesOptions && !isEmpty(aoFields)) {
        fetchAttributesOptions(aoFields);
      }
    }
  }, [filters]);
};

export default useProductAttribute;
